import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import _ from "lodash";

import BackgroundBlock from "../../deliveryNotes/partials/BackgroundBlock";
import Input from "components/Input";
import CNBDatePicker from "components/CNBDatePicker";
import Checkbox from "components/Checkbox";
import Button from "components/Button";
import "../style.scss";
import areaStatementCreateActions from "../actions";
import ICustomer from "models/ICustomer";
import IUser from "models/IUser";
import Select from "components/Select";
import { URLS } from "constants/urlConstants";
import { History } from "history";
import Swal from "helpers/swal";

interface IProps {
  currentCustomer: ICustomer;
  createZant: (object: any) => void;
  userName: string;
  user: IUser;
  userLanguage: string;
  intl: any;
  statementLine: any;
  history: History;
}

interface IState {
  [key: string]: any;
  error: any;
  touched: any;
  formError?: any[];
  isFormValid: boolean;

  Id: string;
  date: Date;
  cultivar: any;
  harvestYear: any;
  noStatementLine: boolean;

  cultivationLocations: Array<{
    area: string;
    RR: string;
    description: string;
  }>;

  t1Measurements: Array<{
    area: string;
    RR: string;
    description: string;
  }>;

  surfaceMaterials: Array<{
    area: string;
    RR: string;
    description: string;
  }>;

  areaalAvailable: boolean;

  plantingMaterial: Array<{
    buyerCompanyName: string;
    address: string;
    residence: string;
    numberOfPortions: string;
    quantity: string;
    orderNumber: string;
    IVB: string;
  }>;

  licensor: Partial<ICustomer>;
  licensee: Partial<ICustomer>;
}

interface IError {
  title: string;
  description: string;
}

class AreaStatementZant extends React.Component<IProps, IState> {
  private baseState: any;

  constructor(props) {
    super(props);
    const { statementLine } = this.props;

    this.state = {
      Id: statementLine?.Id,
      isFormValid: false,
      error: {
        plantingMaterials: [
          {
            buyerCompanyName: null,
            address: null,
            residence: null,
            numberOfPortions: null,
            quantity: null,
            orderNumber: null,
            IVB: { error: "Required", touched: false },
          },
        ],
      },
      touched: {},
      itemId: statementLine?.LicenceContractLine?.Item?.Number,
      date: new Date(),
      cultivar: statementLine
        ? statementLine?.LicenceContractLine?.LicenceContract?.Cultivar
        : "",
      harvestYear: statementLine
        ? statementLine?.AreaStatement?.HarvestYear
        : null,
      noStatementLine: false,
      cultivationLocations: [
        {
          area: "Oppervlakte 1",
          RR: "",
          description: "",
        },
      ],
      surfaceMaterials: [
        {
          area: "Oppervlakte 1",
          RR: "",
          description: "",
        },
      ],
      t1Measurements: [
        {
          area: "Oppervlakte 1",
          RR: "",
          description: "",
        },
      ],
      areaalAvailable: false,
      plantingMaterial: [
        {
          buyerCompanyName: "",
          address: "",
          residence: "",
          numberOfPortions: "",
          quantity: "",
          orderNumber: "",
          IVB: "",
        },
      ],
      licensor: statementLine?.LicenceContractLine?.LicenceContract?.Licensor,
      licensee: statementLine?.LicenceContractLine?.LicenceContract?.Licensee,
      userLanguage: this.props.userLanguage,
    };

    this.baseState = this.state;
  }

  public componentDidMount() {
    const { statementLine, history } = this.props;
    if (_.isEmpty(statementLine) || !statementLine) {
      history.push(URLS.AREA_STATEMENT_CREATE_URL);
      return;
    }
  }

  public componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ) {
    if (
      prevState.areaalAvailable !== this.state.areaalAvailable ||
      prevState.noStatementLine !== this.state.noStatementLine
    ) {
      // this.validateLines();
    }
    if (
      prevState.surfaceMaterials !== this.state.surfaceMaterials ||
      prevState.cultivationLocations !== this.state.cultivationLocations ||
      prevState.plantingMaterial !== this.state.plantingMaterial ||
      this.state.t1Measurements !== prevState.t1Measurements
    ) {
      // this.validateLines();
    }
  }

  private handleFieldChange(name, value) {
    this.setState({ [name]: value });
  }

  private handleAreaalChange(name, value) {
    if (name === "notAreaalAvailable") {
      this.setState({ areaalAvailable: false });
    } else {
      this.setState({ areaalAvailable: true });
    }
  }

  private handleAddCultivationLocations = (e) => {
    e.preventDefault();
    const emptyState = {
      area: `Oppervlakte ${this.state.cultivationLocations.length + 1}`,
      RR: "",
      description: "",
    };
    this.setState({
      cultivationLocations: this.state.cultivationLocations.concat([
        emptyState,
      ]),
    });
  };

  private handleAddSurfaceMaterials = (e) => {
    e.preventDefault();
    const emptyState = {
      area: `Oppervlakte ${this.state.surfaceMaterials.length + 1}`,
      RR: "",
      description: "",
    };
    this.setState({
      surfaceMaterials: this.state.surfaceMaterials.concat([emptyState]),
    });
  };

  private handleAddT1Measurements = (e) => {
    e.preventDefault();
    const emptyState = {
      area: `Oppervlakte ${this.state.t1Measurements.length + 1}`,
      RR: "",
      description: "",
    };
    this.setState({
      t1Measurements: this.state.t1Measurements.concat([emptyState]),
    });
  };

  private onCultivationLocationsChange = (e: any, index: number) => {
    const updatedValues = this.state.cultivationLocations.map(
      (transaction, i: number) =>
        index === i
          ? Object.assign(transaction, { [e.target.name]: e.target.value })
          : transaction
    );
    this.setState({ ...this.state, cultivationLocations: [...updatedValues] });
  };

  private onT1MeasurementsChange = (e: any, index: number) => {
    const updatedValues = this.state.t1Measurements.map(
      (transaction, i: number) =>
        index === i
          ? Object.assign(transaction, { [e.target.name]: e.target.value })
          : transaction
    );
    this.setState({ ...this.state, t1Measurements: [...updatedValues] });
  };

  private onSurfaceMaterialChange = (e: any, index: number) => {
    const updatedValues = this.state.surfaceMaterials.map(
      (transaction, i: number) =>
        index === i
          ? Object.assign(transaction, { [e.target.name]: e.target.value })
          : transaction
    );
    this.setState({ ...this.state, surfaceMaterials: [...updatedValues] });
    // this.validateLines();
  };

  private handleAddPlantingMaterial = (e) => {
    e.preventDefault();
    const emptyState = {
      buyerCompanyName: "",
      address: "",
      residence: "",
      numberOfPortions: "",
      quantity: "",
      orderNumber: "",
      IVB: "",
    };

    this.setState({
      plantingMaterial: this.state.plantingMaterial.concat([emptyState]),
    });
  };

  private onPlantingMaterialChange = (e: any, index: number) => {
    const updatedValues = this.state.plantingMaterial.map(
      (transaction, i: number) =>
        index === i
          ? Object.assign(transaction, { [e.target.name]: e.target.value })
          : transaction
    );
    this.setState({ ...this.state, plantingMaterial: [...updatedValues] });
    // this.validateLines();
  };

  private onPlantingMaterialIVBChange = (e: any, index: number) => {
    const updatedValues = this.state.plantingMaterial.map(
      (transaction, i: number) =>
        index === i ? Object.assign(transaction, { IVB: e.value }) : transaction
    );
    this.setState({ ...this.state, plantingMaterial: [...updatedValues] });
    // this.validateLines();
  };

  private handleDeleteRow = (e: Event, index: number, object) => {
    e.preventDefault();
    let updatedList = [] as any;

    if (object === "cultivationLocations") {
      updatedList = [...this.state.cultivationLocations];
    } else if (object === "surfaceMaterials") {
      updatedList = [...this.state.surfaceMaterials];
    } else if (object === "t1Measurements") {
      updatedList = [...this.state.t1Measurements];
    } else {
      updatedList = [];
    }
    updatedList.splice(index, 1);
    this.setState({
      [object]: updatedList,
    });
  };

  private handleDeletePlantingRow = (e: Event, index: number) => {
    e.preventDefault();
    const updatedList = [...this.state.plantingMaterial];
    updatedList.splice(index, 1);
    this.setState({
      plantingMaterial: updatedList,
    });
  };

  private validateLines(): boolean {
    let isLineFilled = false;
    const {
      cultivationLocations,
      surfaceMaterials,
      plantingMaterial,
      areaalAvailable,
      noStatementLine,
    } = this.state;

    if (noStatementLine && !areaalAvailable) {
      this.setState({ isFormValid: true });
      return true;
    }

    if (areaalAvailable && plantingMaterial.length > 0) {
      for (let index = 0; index < plantingMaterial.length; index++) {
        isLineFilled = Object.values(plantingMaterial[index]).every(
          (value) => value !== "" && value !== null
        );

        if (isLineFilled) {
          this.setState({ isFormValid: true });
        } else {
          this.setState({ isFormValid: false });
          break;
        }
      }
    }
    if ((areaalAvailable && !isLineFilled) || plantingMaterial.length < 1) {
      this.setState({ isFormValid: false });
      return false;
    }

    const generatedArray = { cultivationLocations, surfaceMaterials };
    for (const item in generatedArray) {
      if (generatedArray.hasOwnProperty(item)) {
        for (let index = 0; index < generatedArray[item].length; index++) {
          if (!isLineFilled) {
            isLineFilled = Object.values(generatedArray[item][index]).every(
              (value) => {
                return value !== null && value !== "";
              }
            );
          }
          if (isLineFilled) {
            this.setState({ isFormValid: true });
          } else {
            this.setState({ isFormValid: false });
            break;
          }
        }
      }
    }
    return isLineFilled;
  }

  private isFormInvalidOnSubmit(): boolean {
    const {
      intl: { formatMessage },
    } = this.props;
    let isPartiallyFilled;
    const {
      cultivationLocations,
      surfaceMaterials,
      plantingMaterial,
      noStatementLine,
      areaalAvailable,
    } = this.state;

    if (areaalAvailable) {
      for (let index = 0; index < plantingMaterial.length; index++) {
        isPartiallyFilled =
          isEmpty(Object.values(plantingMaterial[index])) &&
          hasValue(Object.values(plantingMaterial[index]));
        if (isPartiallyFilled) {
          Swal.alert(
            "warning",
            `${"Plantgoed verkocht aan"}
                ${formatMessage({ id: "NOT_COMPLETELY_FILLED" })}`
          );
        }
      }
    }
    if (areaalAvailable && isPartiallyFilled) {
      return true;
    }

    if (!noStatementLine) {
      const generatedArray = { cultivationLocations, surfaceMaterials };
      for (const item in generatedArray) {
        if (generatedArray.hasOwnProperty(item)) {
          for (let index = 0; index < generatedArray[item].length; index++) {
            const filteredLine = _.flow([
              Object.entries,
              (arr) => arr.filter(([key, value]) => key !== "area"),
              Object.fromEntries,
            ])(generatedArray[item][index]);
            isPartiallyFilled =
              isEmpty(Object.values(filteredLine)) &&
              hasValue(Object.values(filteredLine));
            // if (isPartiallyFilled) {
            //   Swal.alert(
            //     "warning",
            //     `${generatedArray[item][index].area}
            //     ${formatMessage({ id: "NOT_COMPLETELY_FILLED" })}`
            //   );
            //   return true;
            // }
          }
        }
      }
    }

    function isEmpty(array) {
      return array.some((value) => value === "");
    }

    function hasValue(array) {
      return array.some((value) => !!value);
    }

    return isPartiallyFilled;
  }

  private handleSubmitForm = (e) => {
    e.preventDefault();
    const { createZant } = this.props;
    createZant(this.state);
    this.resetForm();
  };

  private handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      return false;
    }
  };

  private resetForm = () => {
    this.setState({
      ...this.baseState,
      cultivationLocations: [
        {
          area: "Oppervlakte 1",
          RR: "",
          description: "",
        },
      ],
      plantingMaterial: [
        {
          buyerCompanyName: "",
          address: "",
          residence: "",
          numberOfPortions: "",
          quantity: "",
          orderNumber: "",
          IVB: "",
        },
      ],
    });
  };

  public render() {
    const {
      date,
      isFormValid,
      cultivar,
      harvestYear,
      noStatementLine,
      areaalAvailable,
      cultivationLocations,
      surfaceMaterials,
      contractorDetail,
      plantingMaterial,
      t1Measurements,
    } = this.state;
    const {
      intl: { formatMessage },
      user,
    } = this.props;
    return (
      <div>
        <FormattedMessage id="AREA_STATEMENT_MAKE" tagName="h1" />
        <form id="new-cultivation-advice" onKeyDown={this.handleKeyDown}>
          <BackgroundBlock className="advice-form" key={1}>
            <Input
              name="harvestYear"
              label="HARVEST_YEAR"
              placeholder="HARVEST_YEAR"
              value={harvestYear}
              onChange={(e) =>
                this.handleFieldChange("harvestYear", e.target.value)
              }
              required
              disabled
            />
            <Input
              name="cultivar"
              label="CULTIVAR"
              placeholder="CULTIVAR"
              value={cultivar}
              onChange={(e) =>
                this.handleFieldChange("cultivar", e.target.value)
              }
              required
              disabled
            />
            <div className="datum">
              <FormattedMessage id="DATE" tagName="label" />
              <CNBDatePicker
                name="date"
                startDate={new Date()}
                onChange={(value) => this.handleFieldChange("date", value)}
              />
            </div>
            <div className="checkbox-row">
              <Checkbox
                checked={noStatementLine}
                onChange={(value) =>
                  this.handleFieldChange("noStatementLine", value)
                }
                borderColor="#CDD2D6"
                labelText={"AREA_STATEMENT_AVAILABLE"}
              />
            </div>
          </BackgroundBlock>
          {/* cultivationLocations starts*/}
          {!noStatementLine && (
            <BackgroundBlock className="advice-form" key={2}>
              <div className="cultivationLocationsTable mt-30 pb-20 border-bottom">
                <p className="mb-20">
                  <FormattedMessage id="LIVERBAR_NOTE_ZANT" />
                </p>
                <table className="cultivationLocationsTable">
                  <thead>
                    <tr>
                      <th className="capitalizeText">
                        <FormattedMessage id="SURFACE" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="RR" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="CULTIVATION_LOCATIONS" />
                      </th>
                      <th className="capitalizeText"> &nbsp; </th>
                    </tr>
                  </thead>
                  <tbody>
                    {cultivationLocations.map((cultivationLocation, index) => (
                      <tr>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onCultivationLocationsChange(e, index)
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={cultivationLocation.area}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onCultivationLocationsChange(e, index)
                            }
                            name="RR"
                            placeholder="RR"
                            className="half-width-50 "
                            value={cultivationLocation.RR}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onCultivationLocationsChange(e, index)
                            }
                            name="description"
                            placeholder="CULTIVATION_LOCATIONS"
                            className="half-width-50"
                            value={cultivationLocation.description}
                          />
                        </td>
                        <td className="addRow">
                          <Button
                            onClick={(e) =>
                              this.handleDeleteRow(
                                e,
                                index,
                                "cultivationLocations"
                              )
                            }
                            kind="primary"
                            type="button"
                            className="p-12"
                          >
                            MINUS_SIGN
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="button-container border-bottom">
                <Button
                  onClick={this.handleAddCultivationLocations}
                  kind="primary"
                  type="button"
                  className="p-10"
                >
                  PLUS_SIGN
                </Button>
              </div>
            </BackgroundBlock>
          )}
          {/* cultivationLocations ends*/}

          {/* t1Measurements starts*/}
          {!noStatementLine && (
            <BackgroundBlock className="advice-form" key={2}>
              <div className="cultivationLocationsTable mt-30 pb-20 border-bottom">
                <p className="mb-20">
                  <FormattedMessage id="SURFACE_TITLE" />
                </p>
                <table className="cultivationLocationsTable">
                  <thead>
                    <tr>
                      <th className="capitalizeText">
                        <FormattedMessage id="SURFACE" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="RR" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="CULTIVATION_LOCATIONS" />
                      </th>
                      <th className="capitalizeText"> &nbsp; </th>
                    </tr>
                  </thead>
                  <tbody>
                    {t1Measurements.map((t1Measurement, index) => (
                      <tr>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onT1MeasurementsChange(e, index)
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={t1Measurement.area}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onT1MeasurementsChange(e, index)
                            }
                            name="RR"
                            placeholder="RR"
                            className="half-width-50 "
                            value={t1Measurement.RR}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onT1MeasurementsChange(e, index)
                            }
                            name="description"
                            placeholder="CULTIVATION_LOCATIONS"
                            className="half-width-50"
                            value={t1Measurement.description}
                          />
                        </td>
                        <td className="addRow">
                          <Button
                            onClick={(e) =>
                              this.handleDeleteRow(e, index, "t1Measurements")
                            }
                            kind="primary"
                            type="button"
                            className="p-12"
                          >
                            MINUS_SIGN
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="button-container border-bottom">
                <Button
                  onClick={this.handleAddT1Measurements}
                  kind="primary"
                  type="button"
                  className="p-10"
                >
                  PLUS_SIGN
                </Button>
              </div>
            </BackgroundBlock>
          )}
          {/* t1Measurements ends*/}

          {/* Surface materials section starts*/}
          {!noStatementLine && (
            <BackgroundBlock className="advice-form" key={3}>
              <div className="cultivationLocationsTable mt-30 pb-20 border-bottom">
                <p className="mb-20">
                  <FormattedMessage id="PLANTING_MATERIAL_NOTE_ZANT" />
                </p>
                <table className="cultivationLocationsTable">
                  <thead>
                    <tr>
                      <th className="capitalizeText">
                        <FormattedMessage id="SURFACE" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="RR" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="CULTIVATION_LOCATIONS" />
                      </th>
                      <th className="capitalizeText"> &nbsp; </th>
                    </tr>
                  </thead>
                  <tbody>
                    {surfaceMaterials.map((surfaceMaterial, index) => (
                      <tr>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSurfaceMaterialChange(e, index)
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={surfaceMaterial.area}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSurfaceMaterialChange(e, index)
                            }
                            name="RR"
                            placeholder="RR"
                            className="half-width-50 "
                            value={surfaceMaterial.RR}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSurfaceMaterialChange(e, index)
                            }
                            name="description"
                            placeholder="CULTIVATION_LOCATIONS"
                            className="half-width-50"
                            value={surfaceMaterial.description}
                          />
                        </td>
                        <td className="addRow">
                          <Button
                            onClick={(e) =>
                              this.handleDeleteRow(e, index, "surfaceMaterials")
                            }
                            kind="primary"
                            type="button"
                            className="p-12"
                          >
                            MINUS_SIGN
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="button-container border-bottom">
                <Button
                  onClick={this.handleAddSurfaceMaterials}
                  kind="primary"
                  type="button"
                  className="p-10"
                >
                  PLUS_SIGN
                </Button>
              </div>
            </BackgroundBlock>
          )}
          {/* Surface materials section ends*/}

          <BackgroundBlock className="advice-from" key={5}>
            <div className="plantingMaterialCheckSection">
              <div className="formLabel">
                <FormattedMessage id="PLANTING_MATERIAL_SOLD" /> :
              </div>
              <div className="checkbox-container">
                <div>
                  <Checkbox
                    key={1}
                    checked={areaalAvailable}
                    borderColor="#CDD2D6"
                    labelText={"YES"}
                    onChange={(value) =>
                      this.handleAreaalChange("areaalAvailable", value)
                    }
                  />
                </div>
                <div>
                  <Checkbox
                    key={2}
                    checked={!areaalAvailable}
                    borderColor="#CDD2D6"
                    labelText={"NO"}
                    onChange={(value) =>
                      this.handleAreaalChange("notAreaalAvailable", value)
                    }
                  />
                </div>
              </div>
            </div>
          </BackgroundBlock>
          {areaalAvailable && (
            <BackgroundBlock className="advice-form" key={6}>
              <div className="mt-30 pb-20 border-bottom">
                <table className="plantingMaterialTable">
                  <thead>
                    <tr>
                      <th className="capitalizeText">
                        <FormattedMessage id="BUYER_COMPANY_NO_KV" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="ADDRESS" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="RESIDENCE" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="PORTIONS" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="QUANTITY_KG" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="ORDERS_NUMBER" />
                      </th>
                      <th className="capitalizeText" colSpan={1}>
                        <FormattedMessage id="IVB" />
                      </th>
                      <th className="capitalizeText">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {plantingMaterial.map((plantingMaterial, index) => (
                      <tr>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onPlantingMaterialChange(e, index)
                            }
                            name="buyerCompanyName"
                            placeholder="BUYER_COMPANY_NO_KV"
                            value={plantingMaterial.buyerCompanyName}
                            className="half-width-50"
                            required
                          />
                        </td>
                        <td>
                          <Input
                            value={plantingMaterial.address}
                            onChange={(e) =>
                              this.onPlantingMaterialChange(e, index)
                            }
                            name="address"
                            placeholder="ADDRESS"
                            className="half-width-50"
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onPlantingMaterialChange(e, index)
                            }
                            name="residence"
                            placeholder="RESIDENCE"
                            value={plantingMaterial.residence}
                            className="half-width-50"
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onPlantingMaterialChange(e, index)
                            }
                            name="numberOfPortions"
                            placeholder="PORTIONS"
                            value={plantingMaterial.numberOfPortions}
                            className="half-width-50"
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onPlantingMaterialChange(e, index)
                            }
                            name="quantity"
                            placeholder="QUANTITY_KG"
                            value={plantingMaterial.quantity}
                            className="half-width-50"
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onPlantingMaterialChange(e, index)
                            }
                            name="orderNumber"
                            placeholder="ORDERS_NUMBER"
                            value={plantingMaterial.orderNumber}
                            className="half-width-50"
                          />
                        </td>
                        <td>
                          <Select
                            name="IVB"
                            selectedOption={plantingMaterial.IVB}
                            required
                            options={[
                              { value: "CNB", label: "CNB" },
                              { value: "Hobaho", label: "Hobaho" },
                              { value: "IGH", label: "IGH" },
                              {
                                value: "Rechtstreeks",
                                label: formatMessage({ id: "DIRECT" }),
                              },
                              {
                                value: "Overig",
                                label: formatMessage({ id: "OTHER" }),
                              },
                            ]}
                            onChange={(e) =>
                              this.onPlantingMaterialIVBChange(e, index)
                            }
                            className="half-width-50"
                            // meta={{error: this.state.error.plantingMaterials[index].error, touched: this.state.error.plantingMaterials[index].error}}
                          />
                        </td>
                        <td className="addRow">
                          <Button
                            onClick={(e) =>
                              this.handleDeletePlantingRow(e, index)
                            }
                            kind="primary"
                            type="button"
                            className="p-12"
                          >
                            MINUS_SIGN
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="button-container border-bottom">
                <Button
                  onClick={this.handleAddPlantingMaterial}
                  kind="primary"
                  type="button"
                  className="p-10"
                >
                  PLUS_SIGN
                </Button>
              </div>
            </BackgroundBlock>
          )}
          <BackgroundBlock className="advice-form" key={7}>
            <div className="button-container">
              <Button
                type="button"
                kind="primary"
                onClick={this.handleSubmitForm}
              >
                SUBMIT
              </Button>
            </div>
          </BackgroundBlock>
        </form>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    userName: state.app.userName,
    user: state.app.user,
    currentCustomer: state.app.currentCustomer,
    userLanguage: state.app.user.profile.Language,
    statementLine: state.areaStatements.statementLine,
  }),
  {
    createZant: areaStatementCreateActions.createZant,
  }
)(injectIntl(AreaStatementZant));
